import { motion } from "framer-motion";
import { Megaphone, MousePointerClick, BotMessageSquare, CalendarCheck, BarChart3 } from "lucide-react";

const steps = [
  {
    icon: Megaphone,
    step: "01",
    title: "Traffic",
    description: "Increase high-converting traffic through SEO, Content Strategy, Google & Meta Ads",
  },
  {
    icon: MousePointerClick,
    step: "02",
    title: "Conversion",
    description: "Landing pages built to capture and qualify leads",
  },
  {
    icon: BotMessageSquare,
    step: "03",
    title: "Automation",
    description: "Instant SMS, WhatsApp & email follow-ups",
  },
  {
    icon: CalendarCheck,
    step: "04",
    title: "Booking",
    description: "Turn leads into scheduled appointments automatically",
  },
  {
    icon: BarChart3,
    step: "05",
    title: "Optimization",
    description: "We analyze your daily signals and optimize campaigns in real time",
  },
];

const HowItWorksSection = () => {
  return (
    <section id="how-it-works" className="py-24 px-4 bg-secondary">
      <div className="max-w-6xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-display-md font-bold text-foreground mb-4">
            How We Turn Leads Into Customers
          </h2>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto">
            A proven 4-step system that converts more of your leads into paying customers.
          </p>
        </motion.div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-5 gap-6">
          {steps.map((step, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.15 }}
              className="relative bg-card border border-border rounded-2xl p-6 text-center hover:shadow-lg hover:border-primary/30 transition-all duration-300"
            >
              <div className="text-xs font-bold text-primary/50 mb-4">{step.step}</div>
              <div className="mx-auto mb-4 w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center">
                <step.icon className="h-6 w-6 text-primary" />
              </div>
              <h3 className="text-lg font-bold text-foreground mb-2">{step.title}</h3>
              <p className="text-sm text-muted-foreground leading-relaxed">{step.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;
